/*
* This reducer file handles reducer's state for all actions that are related to profile
*/
const initialState={
	profileDetail: null,
	imageUpdate: false,
	addEditDeleteTeamMember: false,
	editPasswordError: false,
	checkPasswordError: false
};
export default function profileEdit(state=initialState,action){
	switch(action.type)
	{
		case 'EDIT_PROFILE_PIC_REQUEST_SUCCESS':
			return Object.assign({}, state, {
				imageUpdate: action.profileupdate
		     });
		case 'EDIT_PROFILE_REQUEST_SUCCESS':
			return Object.assign({}, state, {
				profileDetail: action.profileupdate,
				imageUpdate: true
		     });
		case 'Unset Profile Edit Flag':
			return Object.assign({}, state, {
				profileDetail: null,
				imageUpdate: false,
				addEditDeleteTeamMember: false
		     });
		case 'Add Edit Delete TeamMember':
			return Object.assign({}, state, {
				profileDetail: null,
				addEditDeleteTeamMember: true
		     });
		case 'EDIT_PASS_REQUEST':

		case 'CHECK_PASS_REQUEST':
			return state;
		case 'EDIT_PASS_SUCCESS':
			return Object.assign({}, state, {
				editPasswordError: false,
		     });
		case 'EDIT_PASS_FAIL':
			return Object.assign({}, state, {
				editPasswordError: true,
		     });
		case 'CHECK_PASS_SUCCESS':
			return Object.assign({}, state, {
				checkPasswordError: false,
		     });
		case 'CHECK_PASS_FAIL':
			return Object.assign({}, state, {
				checkPasswordError: true,
		     });
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/Reducers/profile.js